<mat-sidenav-container
  hasBackdrop="true"
  class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0"
>
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div
      class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between"
    >
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>
          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Qué tanto convierten las visitas en ventas.
                Compara visitas planeadas vs. realizadas y 
                ventas logradas. Úsalo para identificar 
                dónde se visita pero no se vende, y 
                ajustar la estrategia.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Efectividad
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Visualiza y exporta mediante la agrupación del <b>viaje</b>, la
          duración y validación por GPS en los procesos de <b>visita</b> en los
          <b>socios de negocio</b>.
        </div>
      </div>
      <div
        class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between"
      >
        <div class="flex shrink-0">
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Reporte de Visitas</div> -->
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <button
            class="ml-3 hidden sm:inline-flex"
            mat-flat-button
            [color]="'primary'"
            (click)="onExportButtonPressed()"
            matTooltip="Exportar"
          >
            <mat-icon
              class="icon-size-5"
              [svgIcon]="'heroicons_outline:document-arrow-down'"
            ></mat-icon>
            <span class="ml-2">Exportar</span>
          </button>
        </div>
      </div>
    </div>
    <div
      class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent"
    >
      <!-- Main Content (SmartGrid) -->
      <div class="pt-1 mx-6">
        <app-smart-grid
          [data]="data"
          [columnDefs]="columnDefs"
          [config]="gridConfig"
          [loading]="isLoading"
          [totalRecords]="totalItems"
          [detailTemplate]="rowDetailsTemplate"
          (pageChanged)="onPageChange($event)"
          (sortChanged)="onSortChange($event)"
          (rowExpansionChanged)="onRowExpansionChanged($event)">
        </app-smart-grid>
      </div>
    </div>
  </div>
  <!-- Modales -->
  <ng-template #rowDetailsTemplate let-row="row">
    <div class="overflow-hidden">
      <div class="flex border-b">
        <form class="flex w-full flex-col">
          <div class="flex flex-col py-3 px-12 sm:flex-row">
            <div class="flex flex-auto flex-wrap">
              <div class="p-2 flex w-full flex-col">
                <table
                  class="w-width min-w-500 overflow-y-visible mat-elevation-z"
                  mat-table
                  [dataSource]="dataSourceDetail"
                  matSort
                  matSortActive="dateTimeStart"
                >
                  <ng-container matColumnDef="geo">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="text-left first-col table-tittle w-min-detail"
                    ></th>
                    <td
                      mat-cell
                      *matCellDef="let detail"
                      class="text-left first-col table-text"
                    >
                      <mat-icon
                        color="primary"
                        (click)="openModal(detail, 'D')"
                        [matTooltip]="
                          detail?.geoPoint.length > 0
                            ? 'Ver'
                            : 'No hay ubicación'
                        "
                        class="pointer-icon"
                        matBadgeColor="accent"
                        matBadgeSize="small"
                        aria-hidden="false"
                        >place</mat-icon
                      >
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="bPartner">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="px-6 text-left first-col table-tittle"
                    >
                      Socio de Negocio
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let detail"
                      class="px-6 text-left first-col table-text"
                    >
                      <p class="table-text-m text-uppercase">
                        <span class="table-text-code">{{
                          detail?.shipToExternalKeyCode
                        }}</span
                        ><br />
                        {{ detail?.shipToName }}
                      </p>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="visit">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="px-6 text-left first-col table-tittle"
                    >
                      Visita
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let detail"
                      class="px-6 text-left first-col table-text"
                    >
                      {{ detail?.reasonForVisitName }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="documentNumber">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="px-6 text-left first-col table-tittle"
                    >
                      Nro. Documento
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let detail"
                      class="px-6 text-left first-col table-text"
                    >
                      {{
                        detail.serials &&
                        detail.serials.trim() !== "" &&
                        detail.serials !== "null"
                          ? detail.serials
                          : ""
                      }}
                    </td>
                  </ng-container>
                  <!-- Inicio -->
                  <ng-container matColumnDef="dateTimeStart">
                    <th
                      mat-header-cell
                      mat-sort-header
                      *matHeaderCellDef
                      class="text-left"
                    >
                      Duración
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let data"
                      class="text-left text-sm"
                    >
                      <p class="pr-2">
                        <span
                          class="font-semibold"
                          [matTooltip]="'Fecha Inicio'"
                          >FI:
                        </span>
                        {{
                          data?.dateTimeStart
                            ? (data?.dateTimeStart | date: "dd-MM-yyyy HH:mm")
                            : "-"
                        }}
                      </p>
                      <p class="pr-2">
                        <span class="font-semibold" [matTooltip]="'Fecha Fin'"
                          >FF:
                        </span>
                        {{
                          data?.dateTimeEnd
                            ? (data?.dateTimeEnd | date: "dd-MM-yyyy HH:mm")
                            : "-"
                        }}
                      </p>
                    </td>
                  </ng-container>
                  <!-- <ng-container matColumnDef="dateTimeStart">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">Fecha Hora Inicio</th>
                                        <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                                            {{detail?.dateTimeStart | date: 'dd/MM/yyyy HH:mm'}}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="endHour">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">Fecha Hora Final</th>
                                        <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                                            {{detail?.dateTimeEnd |  date: 'dd/MM/yyyy HH:mm'}}
                                        </td>
                                    </ng-container> -->
                  <ng-container matColumnDef="duration">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="px-6 text-left first-col table-tittle"
                    >
                      Duración Visita
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let detail"
                      class="px-6 text-center first-col table-text"
                    >
                      {{ detail.duration | FormatToHour }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="location">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="px-6 text-left first-col table-tittle"
                    >
                      Ubicación GPS
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let detail"
                      class="px-6 text-left first-col table-text"
                    >
                      <p class="table-text-m text-left" style="min-width: 90px">
                        <b>APP: </b>{{ detail?.geoPoint ?? "-" }}<br />
                        <b><span>AVE:</span><br /></b
                        >{{ detail?.address?.[0]?.geolocationPoint ?? "-" }} <br>
                        <b><span>Distancia:</span><br></b>
                        {{ detail?.distance ?? "-" }}
                      </p>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="wasTheVisitOnSite">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="px-6 text-center first-col table-tittle"
                    >
                      Zona
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let detail"
                      class="px-6 text-center first-col table-text"
                    >
                      {{ detail.wasTheVisitOnSite ? "SI" : "NO" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="validVisit">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="px-6 text-center first-col table-tittle"
                    >
                      Visita Válida
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let detail"
                      class="px-6 text-center first-col table-text"
                    >
                      {{ detail.validVisit ? "SI" : "NO" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="visitImages">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="text-left first-col table-tittle w-min-detail"
                    ></th>
                    <td
                      mat-cell
                      *matCellDef="let detail"
                      class="text-left first-col table-text"
                    >
                      <mat-icon
                        color="primary"
                        matBadge="{{ detail?.visitImages?.length || 0 }}"
                        [matTooltip]="
                          detail?.visitImages?.length > 0
                            ? 'Ver imágenes'
                            : 'Sin imágenes'
                        "
                        class="pointer-icon"
                        (click)="openImageCarousel(detail.visitImages)"
                        matBadgeColor="accent"
                        matBadgeSize="small"
                        aria-hidden="false"
                        >photo_library</mat-icon
                      >
                    </td>
                  </ng-container>

                  <!-- Header Row -->
                  <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumnsDetail"
                    class="bg-gray-100 dark:bg-gray-900"
                  ></tr>
                  <!-- Fila principal -->
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumnsDetail"
                    class="border-b"
                  ></tr>
                </table>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </ng-template>

  <ng-template #noData>
    <span> - </span>
  </ng-template>

  <!-- Filtros -->
  <app-filter
    (onFilterEvent)="findAllWithCount()"
    (onCleanEvent)="onClearFilter()"
    (onPanelOpened)="onFilterPanelOpened()"
  >
    <app-dates-filters
      [form]="form"
      [showDateCreationRange]="true"
    ></app-dates-filters>
    <app-configuration-filters
      [form]="form"
      [company]="true"
      [salesOffice]="true"
      [loadData]="loadFiltersData"
    ></app-configuration-filters>
    <app-routes-filters [form]="form" [route]="true" [loadData]="loadFiltersData"></app-routes-filters>
    <app-business-partners-filters
      [form]="form"
      [businessPartner]="true"
      [loadData]="loadFiltersData"
    ></app-business-partners-filters>
  </app-filter>
</mat-sidenav-container>
